<script>
export default {
    asyncData({ redirect }) {
        redirect('/?mod=orderlogin')
    },
}
</script>
